<template>
  <v-container fluid grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-card>
        <v-card-text>
          <v-toolbar>
            <v-toolbar-title>{{ users.length }} {{ $vuetify.t('$vuetify.AdminUsers.users') }}</v-toolbar-title>
            <v-btn to="/admin/password-printout">
              <v-icon left>print</v-icon> {{ $vuetify.t('$vuetify.AdminUsers.passwordlist') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$vuetify.t('$vuetify.AdminUsers.searchLabel')"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>

          <confirm-dialog :show="bulkAddingRole != null" v-on:closed="bulkAddingRole = null" v-on:confirmed="bulkAddRole(true)" :confirm-btn-disalbed="this.ideaSpace == null" confirm-btn-color="primary" confirm-btn-text="$vuetify.AdminUsers.addRole">
            <label class="v-label v-label--active theme--light">{{ $vuetify.t('$vuetify.AdminUsers.users') }}</label>
            <div class="user-listing add-role mb-3">
              <span v-for="user in bulkAddingRole">{{ user }}</span>
            </div>
            <v-select
              name="usergroup"
              v-model="usergroup"
              v-validate="'required'"
              :error-messages="errors.collect('usergroup')"
              :items="usergroups"
              :label="this.$vuetify.t('$vuetify.AdminUsers.formGroup')"
              required
            ></v-select>
            <v-select
              name="ideaSpace"
              v-model="ideaSpace"
              v-validate
              :error-messages="errors.collect('ideaSpace')"
              :items="ideaSpaces"
              :label="this.$vuetify.t('$vuetify.AdminUsers.formIdeaSpace')"
            ></v-select>
          </confirm-dialog>

          <confirm-dialog :show="bulkRemovingRole != null" v-on:closed="bulkRemovingRole = null" v-on:confirmed="bulkRemoveRole(true)" :confirm-btn-disalbed="this.ideaSpace == null" confirm-btn-color="red" confirm-btn-text="$vuetify.AdminUsers.removeRole">
            <label class="v-label v-label--active theme--light">{{ $vuetify.t('$vuetify.AdminUsers.users') }}</label>
            <div class="user-listing remove-role mb-3">
              <span v-for="user in bulkRemovingRole">{{ user }}</span>
            </div>
            <v-select
              name="usergroup"
              v-model="usergroup"
              v-validate="'required'"
              :error-messages="errors.collect('usergroup')"
              :items="usergroups"
              :label="this.$vuetify.t('$vuetify.AdminUsers.formGroup')"
              required
            ></v-select>
            <v-select
              name="ideaSpace"
              v-model="ideaSpace"
              v-validate
              :error-messages="errors.collect('ideaSpace')"
              :items="ideaSpaces"
              :label="this.$vuetify.t('$vuetify.AdminUsers.formIdeaSpace')"
            ></v-select>
          </confirm-dialog>

          <confirm-dialog :show="bulkDeleting != null" v-on:confirmed="bulkDelete(true)" v-on:closed="bulkDeleting = null" confirm-btn-color="red" confirm-btn-text="$vuetify.AdminUsers.deleteConfirm" cancel-btn-text="$vuetify.AdminUsers.deleteCancel">
            <h3>{{ $vuetify.t('$vuetify.AdminUsers.deleteBulkUsersQuestion') }}</h3>
            <div class="user-listing delete-users">
              <span v-for="user in bulkDeleting">{{ user }}</span>
            </div>
          </confirm-dialog>

          <confirm-dialog :show="toDelete != null" :full="true">
            <v-card-title>
              <h3>{{ $vuetify.t('$vuetify.AdminUsers.deleteHeader') }}</h3>
            </v-card-title>
            <v-card-text v-if="toDelete !== null">
              <p>
                {{
                $vuetify.t(
                '$vuetify.AdminUsers.deleteText',
                getUserById(this.toDelete).username
                )
                }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="deleteUser"
                color="red"
              >{{ $vuetify.t('$vuetify.AdminUsers.deleteConfirm') }}</v-btn>
              <v-btn @click="reset">{{ $vuetify.t('$vuetify.AdminUsers.deleteCancel') }}</v-btn>
            </v-card-actions>
          </confirm-dialog>

          <v-data-table
            :headers="headers"
            :items="users"
            :search="search"
            v-model="selected"
            :loading="isLoading"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox :disabled="!props.item.showCheckbox" v-model="selected" :value="props.item.id" style="margin:0px;padding:0px" hide-details />
              </td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.first_name }}</td>
              <td>{{ props.item.last_name }}</td>
              <td>
                <ul v-if="props.item.groups.length >= 1" style="padding:0px;">
                  <li v-for="group in props.item.groups">
                    <span v-if="group.length > 1">
                    {{ $vuetify.t(
                    '$vuetify.rolesCompound.' + group[0],
                    group[2])
                    }}
                    </span>
                    <span v-else>
                    {{ $vuetify.t(
                    '$vuetify.rolesCompound.' + ((group[0] === 'student') ? 'school_student' : group[0]))
                    }}
                    </span>
                  </li>
                </ul>
                <span v-else>{{ $vuetify.t('$vuetify.rolesCompound.noRoles') }}</span>
              </td>
              <td>
                {{ $vuetify.t('$vuetify.AdminUsers.columnHasSetPassword-' +
                props.item.hasSetPassword) }}
              </td>
              <td>
                <v-icon small class="mr-2" @click="() => edit(props.item.id)">edit</v-icon>
                <v-icon small @click="toDelete = props.item.id">delete</v-icon>
              </td>
            </template>

            <template slot="footer">
              <td :colspan="headers.length">
                <v-icon style="transform: rotate(90deg); margin-left: 3px;">subdirectory_arrow_left</v-icon>
                <a @click="markAll()">{{$vuetify.t('$vuetify.AdminUsers.selectAll')}}</a>
                <span>&nbsp;/&nbsp;</span>
                <a @click="unmarkAll()">{{$vuetify.t('$vuetify.AdminUsers.unselectAll')}}</a>

                <span style="margin-left: 6rem;">{{selected.length}} {{ $vuetify.t('$vuetify.AdminUsers.selected') }}:</span>
                <v-btn text small :disabled="selected.length < 1" @click="bulkDelete(false)">{{ $vuetify.t('$vuetify.AdminUsers.delete') }}</v-btn>
                <v-btn text small :disabled="selected.length < 1" @click="bulkAddRole(false)">{{ $vuetify.t('$vuetify.AdminUsers.addRole') }}</v-btn>
                <v-btn text small :disabled="selected.length < 1" @click="bulkRemoveRole(false)">{{ $vuetify.t('$vuetify.AdminUsers.removeRole') }}</v-btn>
              </td>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="info"
              icon="warning"
            >{{ $vuetify.t('$vuetify.AdminUsers.searchNoResults', search) }}</v-alert>
          </v-data-table>

          <v-layout row wrap mt-3>
            <v-flex xs12 sm6>
              <GroupsUsersEdit
                :user="toEdit"
                :users="users"
                :handleCancel="reset"
                :handleSuccess="handleNewUser"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <GroupEditor
                v-if="toEdit != null"
                :user="toEdit"
                :handleSuccess="handleGroupsUpdated"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-slide-y-transition>

    <v-snackbar v-model="showSnackbar" :bottom="true">
      {{ snackbarMsg }}
      <v-btn
        color="pink"
        flat
        @click="showSnackbar = false"
      >{{ $vuetify.t('$vuetify.Snackbar.close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import api from '@/api'
import GroupsUsersEdit from '@/components/GroupsUsersEdit'
import GroupEditor from '@/components/GroupEditor'
import ConfirmDialog from './dialogs/ConfirmDialog'
import {getDefaultGroups} from '../utils/defaultGroups'

export default {
  name: 'GroupsUsers',
  components: {
    ConfirmDialog,
    GroupsUsersEdit,
    GroupEditor
  },
  data: function () {
    const defaultData = {
      usergroup: 'student',
      ideaSpace: null
    }

    return {
      headers: [
        {
          sortable: false,
          value: 'showCheckbox'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminUsers.formLogin'),
          align: 'left',
          sortable: true,
          value: 'username'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminUsers.formFirstName'),
          align: 'left',
          sortable: true,
          value: 'first_name'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminUsers.formLastName'),
          align: 'left',
          sortable: true,
          value: 'last_name'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminUsers.formGroup'),
          align: 'left',
          sortable: true,
          value: 'group_id'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminUsers.columnHasSetPassword'),
          sortable: true,
          value: 'hasSetPassword'
        },
        {
          text: this.$vuetify.t('$vuetify.AdminUsers.columnActions'),
          align: 'center',
          value: null,
          sortable: false
        }
      ],
      isLoading: true,
      users: [],
      toEdit: null,
      toDelete: null,
      search: '',
      showSnackbar: false,
      snackbarMsg: '',
      selected: [],
      bulkDeleting: null,
      bulkAddingRole: null,
      bulkRemovingRole: null,
      ideaSpaces: [],
      usergroup: defaultData.usergroup,
      ideaSpace: defaultData.ideaSpace,
      usergroups: {},
      defaultData: defaultData
    }
  },

  beforeMount: function () {
    this.usergroups = getDefaultGroups(this.$vuetify.t)
    this.getIdeaSpaces()
    this.getUsers()
  },

  methods: {
    markAll: function () {
      const headers = this.headers.filter(h => h.value in this.users[0]).map(h => h.value); const search = this.search.toLowerCase(); let i = 0; let l = headers.length; let val = ''
      this.selected = [...this.users].filter(user => {
        if (user.showCheckbox) {
          for (i = 0; i < l; ++i) {
            val = user[headers[i]]
            if (val != null && typeof val !== 'boolean' && val.toString().toLowerCase().indexOf(search) !== -1) {
              return true
            }
          }
        }
        return false
      }).map(a => a.id)
    },
    unmarkAll: function () {
      this.selected = []
    },
    edit: function (id) {
      this.toEdit = this.getUserById(id)
    },
    reset: function () {
      this.toEdit = null
      this.toDelete = null
      this.bulkDeleting = null
      this.bulkAddingRole = null
      this.bulkRemovingRole = null
      this.usergroup = this.defaultData.usergroup
      this.ideaSpace = this.defaultData.ideaSpace
    },
    getUserById: function (id) {
      return this.users.filter(u => u.id === id).shift()
    },
    getUsers: function () {
      this.isLoading = true

      const parseConfig = entry => Object.assign({}, entry, {
        config: JSON.parse(entry.config)
      })

      // Groups are returned from Postgrest as a composite value, which means
      // they're strings that need to be unpacked
      const parseGroups = entry => Object.assign({}, entry, {
        groups: entry.groups[0] === '(,,)' // Postgres return value for 'no groups'
          ? []
          : entry.groups.map(val => {
            // Remove outer parantheses and split into
            // group_name, space_id, space_name
            return [val['f1'], val['f2'], val['f3']]
          })
      })

      // Insert a boolean field that indicates whether the config field
      // contains a temporary password
      const checkTempPassword = entry => Object.assign({}, entry, {
        hasSetPassword: entry.config.temp_password == null
      })

      const showCheckbox = entry => Object.assign({}, entry, {
        showCheckbox: (entry.groups.filter(g => g[0] === 'admin').length) < 1
      })

      var schoolId
      if (this.$store.getters.selected_school) {
        schoolId = this.$store.getters.selected_school
      }
      api.user.getListing(schoolId)
        .then((res) => {
          this.users = res.data
            .map(parseConfig)
            .map(parseGroups)
            .map(checkTempPassword)
            .map(showCheckbox)
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    getIdeaSpaces: function () {
      const schoolId = this.$store.getters.selected_school
      api.ideaSpace.getIdeaSpaces(schoolId).then((res) => {
        // Return value is transformed so that it is suitable for
        // vuetify's select component
        this.ideaSpaces = res.data.map(sp => ({
          text: sp.title,
          value: sp.id
        }))
        // Add a no-space-assigned option here
        this.ideaSpaces.push({
          text: this.$vuetify.t('$vuetify.AdminUsers.formNoSpaceSelected'),
          value: null
        })
      })
    },
    handleNewUser: function () {
      this.isLoading = true
      this.reset()
      this.getUsers()
    },
    handleGroupsUpdated: function (data) {
      this.isLoading = true
      this.getUsers()
    },
    deleteUser: function () {
      api.user.deleteUser(this.$store.getters.selected_school, this.toDelete)
        .then(res => {
          if (res.status < 400) {
            this.reset()
            this.getUsers()
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.snackbarDeleted')
          } else {
            this.reset()
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.snackbarDeleteFailed')
          }
        })
    },
    bulkDelete: function (confirmed) {
      if (!confirmed) {
        this.bulkDeleting = [...this.users].filter(u => this.selected.indexOf(u.id) !== -1).map(u => u.first_name + ' ' + u.last_name + ' (' + u.username + ')')
      } else {
        api.user.deleteUserBulk(this.$store.getters.selected_school, [...this.selected]).then(res => {
          if (res.status < 400) {
            this.getUsers()
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.snackbarDeleted')
          } else {
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.snackbarDeleteFailed')
          }
          this.reset()
        }).catch(res => {
          this.snackbarMsg = this.$vuetify.t(
            '$vuetify.AdminUsers.snackbarDeleteFailed')
        }).finally(() => {
          this.showSnackbar = true
        })
        this.selected = []
      }
    },
    bulkAddRole: function (confirmed) {
      if (!confirmed) {
        this.bulkAddingRole = [...this.users].filter(u => this.selected.indexOf(u.id) !== -1).map(u => u.first_name + ' ' + u.last_name + ' (' + u.username + ')')
      } else {
        if (this.ideaSpace !== null) {
          api.user.addRoleBulk(this.$store.getters.selected_school, [...this.selected], this.usergroup, this.ideaSpace).then(res => {
            if (res.status < 400) {
              this.getUsers()
              this.snackbarMsg = this.$vuetify.t(
                '$vuetify.AdminUsers.snackbarAddRole')
            } else {
              this.snackbarMsg = this.$vuetify.t(
                '$vuetify.AdminUsers.snackbarAddRoleFailed')
            }
            this.reset()
          }).catch(res => {
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.snackbarAddRoleFailed')
          }).finally(() => {
            this.showSnackbar = true
          })
          this.selected = []
        }
      }
    },
    bulkRemoveRole: function (confirmed) {
      if (!confirmed) {
        this.bulkRemovingRole = [...this.users].filter(u => this.selected.indexOf(u.id) !== -1).map(u => u.first_name + ' ' + u.last_name + ' (' + u.username + ')')
      } else {
        if (this.ideaSpace !== null) {
          api.user.removeRoleBulk(this.$store.getters.selected_school, [...this.selected], this.usergroup, this.ideaSpace).then(res => {
            if (res.status < 400) {
              this.getUsers()
              this.snackbarMsg = this.$vuetify.t(
                '$vuetify.AdminUsers.snackbarRemoveRole')
            } else {
              this.snackbarMsg = this.$vuetify.t(
                '$vuetify.AdminUsers.snackbarRemoveRoleFailed')
            }
            this.reset()
          }).catch(res => {
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.snackbarRemoveRoleFailed')
          }).finally(() => {
            this.showSnackbar = true
          })
          this.selected = []
        }
      }
    }
  }
}
</script>

<style scss>
    .user-listing.add-role,
    .user-listing.remove-role{
      max-height: calc(100vh - 346px);
      overflow: auto;
    }

    .user-listing.delete-users {
      max-height: calc(100vh - 320px);
      overflow: auto;
    }

    .user-listing span::after {
      content: ', ';
      display: inline;
    }

    .user-listing span:last-child::after {
      content: '';
    }
</style>
